import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AffectionTableMetierService} from './affection-table.metier.service';
import {Autowired} from '@angular-ru/autowired';
import {SgiListLayoutComponent} from '@shared/behaviors/list-layout/sgi/sgi-list-layout.component';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-affection-table',
  templateUrl: './affection-table.component.html'
})

export class AffectionTableComponent extends SgiListLayoutComponent implements OnInit {
  @Autowired() recuperationListeDonneesMetier: AffectionTableMetierService;
  @Autowired() metierService: AffectionTableMetierService;

  @Input() currentRow: any;
  @Input() responseAffections: any;
  @Output() responseAffectionsEvent = new EventEmitter<any>();

  formGroup: FormGroup;
  typeRechercheCombo: any[] = [];
  placeholderInputSearch: string;


  constructor() {
    super();
    this.cols = [
      {field: 'codeAffection', header: 'Code affection '},
      {field: 'libelleAffection', header: 'Libelle'},
      {field: 'libelleTypeAffection', header: 'Type affection'},
      {field: 'estExclu', header: 'Est exclu'},
    ];
    this.tableActions = [];
    this.notRowActions = [];
  }

  ngOnInit(): void {
    this.initialiserTypeRechercheCombo();

    this.initFormulaire();

    this.formatTableListAddIndex(this.responseAffections);
  }

  /**
   * Définition des arguments
   */
  defineArgs(): void {
    super.defineArgs();
    const arg = {...this.args};
    this.args = {...arg};
  }

  recuperationDonnees(data?: any) {
    const da = {...this.args, lazyLoadEvent: data, successMute: true, currentRow: this.currentRow};
    this.args = {...da};
    this.metierService.requeteRecuperationListeDonnees(this.getAllRequestParam(), {...this.args}).subscribe((r_Affections) => {
      const responseAffections = r_Affections.body;

      this.formatTableListAddIndex(responseAffections);

      this.responseAffectionsEvent.emit(r_Affections.body);
    });
  }

  formatTableListAddIndex(responseData) {
    if (responseData === undefined) {
      this.dataSource = [];
      this.totalRecords = 0;
      return;
    }
    this.dataSource = responseData.items;
    this.totalRecords = responseData.count;
    if (this.dataSource && this.dataSource.length > 0) {
      this.dataSource.forEach((dat, index) => {
        dat.id_key = index + 1;
      });
    }
  }

  initFormulaire() {
    this.formGroup = this.metierService.initialiserFormulaire(null);
  }

  initialiserTypeRechercheCombo() {
    this.placeholderInputSearch = 'Rechercher';

    this.typeRechercheCombo = [
      { label: 'Libelle', value: 'libelle'},
      { label: 'Code affection', value: 'code_affection'},
      { label: 'Type affection', value: 'type_affection'},
    ];
  }

  handleChangeTypeRecherche(event: any) {
    if (event.value === null) {
      this.placeholderInputSearch = 'Rechercher';

      this.formGroup.patchValue({ inputSearch: null });

      // fonction de recherche assuré avec les valeurs null
      this.recuperationDonnees();
    }

    if (event.value === 'libelle') {
      this.placeholderInputSearch = 'Rechercher par libelle';
    }
    if (event.value === 'code_affection') {
      this.placeholderInputSearch = 'Rechercher par code affection';
    }
    if (event.value === 'type_affection') {
      this.placeholderInputSearch = 'Rechercher par type affection';
    }

    this.formGroup = this.metierService.initialiserFormulaire(this.formGroup.getRawValue());
  }

  rechercheItems(event) {
    if (this.formGroup.getRawValue().selectTypeSearch === null) { return false; }

    // fonction de recherche assuré avec les valeurs entrées
    this.recuperationDonnees();
  }

}
